import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReorderPipe } from './reorder.pipe';

@NgModule({
  declarations: [ReorderPipe], // ✅ Declare the pipe here
  imports: [CommonModule], // ✅ Import CommonModule if required
  exports: [ReorderPipe], // ✅ Export the pipe for use in other modules
})
export class ReorderPipeModule {}
